var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-ntteast"},[(_vm.logoPath)?_c('img',{attrs:{"src":_vm.logoFullUrl,"alt":_vm.logoAlt || ''}}):_c('Retina',{attrs:{"dir":"common","name":_vm.imgName,"extension":"svg","width":"141","height":"32","alt":"NTT東日本"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }